import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "flowObjectTypeId", "actionId", "action"];
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import ABTestBranchActionSummary from 'automation-ui-action-features/actions/ab-test-branch/ABTestBranchActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function ABTestBranchActionCard(_ref) {
  let {
      getHeaderTitle,
      flowObjectTypeId,
      actionId,
      action
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const connection = action.getConnection();
  const numOfBranches = connection.connections.length;
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(ABTestBranchActionSummary, {
      flowObjectTypeId: flowObjectTypeId,
      numOfBranches: numOfBranches
    })
  }));
}
export default ABTestBranchActionCard;